import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=6483cf85&scoped=true"
import script from "./Tel.vue?vue&type=script&lang=js"
export * from "./Tel.vue?vue&type=script&lang=js"
import style0 from "./Tel.vue?vue&type=style&index=0&id=6483cf85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6483cf85",
  null
  
)

export default component.exports